/** @jsxImportSource @emotion/react */

import { MPromotionDetailStyle } from "./index.style";

interface MPromotionDetailProps {
  content?: string | TrustedHTML;
  isSubcribe?: boolean;
}

const MPromotionDetail = ({ content }: MPromotionDetailProps) => {
  // const handleSubscribe = () => {
  //   //
  // };

  return (
    <div css={MPromotionDetailStyle.self}>
      {!!content && (
        <div
          dangerouslySetInnerHTML={{
            __html: content,
          }}
        ></div>
      )}
      {/* {isSubcribe && (
        <div css={MPromotionDetailStyle.btnSubscribe}>
          <Button type="primary" onClick={handleSubscribe}>
            Subscribe
          </Button>
        </div>
      )} */}
    </div>
  );
};

export default MPromotionDetail;
